import { palette } from 'src/styles/colors';
import styled, { css } from 'styled-components';

interface FormResultContainerProps {
  result: 'success' | 'failure';
}

export const FormResultContainer = styled.div<FormResultContainerProps>`
  position: relative;
  padding: 1rem 2rem;
  border-radius: 4px;

  .gatsby-image-wrapper {
    margin: 0 auto;
    display: block;
    position: relative;
    max-width: 24px;
    margin-bottom: 1rem;
  }

  ${({ result }) =>
    result === 'success'
      ? css`
          background-color: rgba(51, 173, 107, 0.2);
          border: 1px solid ${palette.seaweedGreen};
        `
      : css`
          background-color: rgba(173, 51, 51, 0.2);
          border: 1px solid ${palette.softBlue};
        `}
`;
